<template>
  <div class="layout--full-page" style="background: white !important;height: 100vh;">
  	<section class="bg-main w-full" style="position: fixed;top: 0;z-index: 101">
  		<div class="pt-4 md:pt-6 lg:pt-12 xl:pt-24"></div>
  		<div class="pt-4 md:pt-6 lg:pt-12   "></div>
  		<div class="pt-4 md:pt-6 lg:mx-12 xl:mx-24 relative">
  			<div class="mx-6 md:mx-8 lg:mx-12 xl:mx-24 vx-row justify-between items-end">
  				<div class="vx-col w-full md:w-1/2 flex justify-center md:justify-start items-end" style="z-index: 999;">
  					<h4 class="text-warning ml-2 pb-4"><strong>{{ $route.meta.pageTitle || '' }}</strong></h4>	
  				</div>
  				<div class="vx-col w-full md:w-1/2" style="z-index: 999;">
  					<ul class="flex justify-center md:justify-end pb-4">
              <li class="mx-4">
  							<router-link to="/home">
  								<span class="text-warning">Home</span>
  							</router-link>
  						</li>
  						<li class="mx-4">
  							<router-link to="/about">
  								<span class="text-warning">Tentang ZX</span>
  							</router-link>
  						</li>
  						<li class="mx-4">
  							<router-link to="/sahabat-zx">
  								<span class="text-warning">Sahabat ZX</span>
  							</router-link>
  						</li>
  						
  						<li class="mx-4">
  							<router-link to="/zxcare">
  								<span class="text-warning">ZX Care</span>
  							</router-link>
  						</li>
  					</ul>
  				</div>
  				
  			</div>
	  			
  		</div>
  	</section>

  	<section class="md:mx-8 lg:mx-12 xl:mx-24 mt-12">
      <div>
        <vs-divider color="#fff" class="block md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
      </div>
  		<div class="md:mx-8 lg:mx-12 xl:mx-24" id="content">
  			<div class="vx-row">
  				
  				<div class="vx-col w-full">
		            <div class="mx-8">

		              <router-view></router-view>          
		            </div>
  				</div>
  			</div>
  			
  		</div>
  	</section>
    <br><br><br><br>
    <the-light-footer />
  </div>
</template>
<script>
import TheLightFooter from '@/layouts/components/TheLightFooter.vue'

export default {
  components: {
    TheLightFooter
  },
  data: () => ({
    menus: [
      {
        label: 'Tentang Kami',
        url: '/about'
      },
      {
        label: 'Kebijakan Privasi',
        url: '/privacy-policy'
      },
      {
        label: 'Syarat & Ketentuan',
        url: '/terms-conditions'
      },
      {
        label: '<feather-icon icon="HomeIcon"></feather-icon><span class="ml-2">Home</span>',
        url: '/'
      }
    ],
    requirements: [
      'Perolehan dan Pengumpulan Data Pribadi Pengguna',
      'Penggunaan Data Pribadi',
      'Pengungkapan Data Pribadi Pengguna',
      '<i>Cookies</i>',
      'Pilihan Pengguna dan Transparansi',
      'Keamanan, Penyimpanan dan Penghapusan Data Pribadi Pengguna',
      'Akses dan Perbaikan Data Pribadi Pengguna atau Penarikan Kembali Persetujuan',
      'Pengaduan terkait Perlindungan Data Pribadi Pengguna',
      'Hubungi Kami',
      'Penyimpanan dan Penghapusan Informasi',
      'Pembaruan Kebijakan Privasi'
    ]
  })
}
</script>
<style lang="scss">
	.bg-main {
		position: relative;
		background-image: url('/assets/images/footer/bg.svg');
		background-repeat: no-repeat;
		background-size: cover;
	}
  body {
    background: white;
  }
</style>